module.exports = __webpack_public_path__ + "media/images/restaurant/tw_sarvicegenre_bg02-ba5582a339c9968090e0095bc33ab2cd.png";